import { TableHeaderConfigWithType } from '../../components/_EOS/Table/types'
import { Stock } from './Entities/Stock'

export const generateTableHeadersReorderStock = () => {
  const tableHeaders: TableHeaderConfigWithType<Stock>[] = [
    {
      field: 'sku',
      title: 'SKU',
      sortable: true
    },
    {
      field: 'ean13',
      title: 'EAN13',
      sortable: false
    },
    {
      field: 'positionCode',
      title: 'Ubicación',
      sortable: false
    },
    {
      field: 'name',
      title: 'Nombre Producto',
      sortable: false
    },
    {
      field: 'quantity',
      title: 'UN Disponible',
      sortable: true
    }
  ]

  return tableHeaders
}
